import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InfoComponent } from './modules/info/info.component';
import { environment } from '../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { LoyalticInterceptor } from './core/interceptor/interceptor';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { LandingComponent } from './modules/campaign/landing/landing.component';
import { RegisterComponent } from './modules/campaign/register/register.component';
import { RewardsListComponent } from './modules/campaign/rewards-list/rewards-list.component';
import { RewardsDeliverableComponent } from './modules/campaign/rewards-deliverable/rewards-deliverable.component';
import { RewardsDigitalComponent } from './modules/campaign/rewards-digital/rewards-digital.component';
import { CodeEntryComponent } from './modules/campaign/code-entry/code-entry.component';
import { ProfileComponent } from './modules/campaign/profile/profile.component';
import { MyProfileComponent } from './modules/campaign/profile/my-profile/my-profile.component';
import { ProfileOrdersComponent } from './modules/campaign/profile/profile-orders/profile-orders.component';
import { ProfileCodesComponent } from './modules/campaign/profile/profile-codes/profile-codes.component';
import { UserPointsComponent } from './modules/campaign/user-points/user-points.component';
import { LoginComponent } from './modules/campaign/login/login.component';
import { ForgotPasswordComponent } from './modules/campaign/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './modules/campaign/reset-password/reset-password.component';
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { FeedbackComponent } from './modules/support/feedback/feedback.component';
import { FeedbackSuccessComponent } from './modules/support/feedback-success/feedback-success.component';
import { CookieService } from 'ngx-cookie-service';
import { SharedModule } from './modules/shared/shared.module';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Loyaltic } from './core/helpers/api-url.constants';
import { FooterComponent } from './modules/page-layout/footer/footer.component';
import { HeaderComponent } from './modules/page-layout/header/header.component';
import { SupportRulesComponent } from './modules/support/support-rules/support-rules.component';
import { SupportPolicyComponent } from './modules/support/support-policy/support-policy.component';
import { SupportProductsComponent } from './modules/support/support-products/support-products.component';
import { SupportFaqComponent } from './modules/support/support-faq/support-faq.component';
import { LayoutComponent } from './modules/page-layout/layout/layout.component';
import { CampaignModule } from './modules/campaign/campaign.module';
import { EmailReminderComponent } from './modules/shared/email-reminder/email-reminder.component';
import { LocalizationComponent } from './modules/shared/localization/localization.component';
import { GenericPopUpComponent } from './modules/popups/generic-pop-up/generic-pop-up.component';
import { UploadReceiptComponent } from './modules/campaign/upload-receipt/upload-receipt.component';
import { ConfirmReceiptUploadComponent } from './modules/popups/confirm-receipt-upload/confirm-receipt-upload.component';
import { ClickToPlayComponent } from './modules/campaign/click-to-play/click-to-play.component';
import { DevNavigationComponent } from './modules/dev-navigation/dev-navigation.component';
import { CookieComponent } from './modules/support/cookie/cookie.component';
import { IconsModule } from './icons/icons.module';
import { UploadAnimationPopUpComponent } from './modules/popups/upload-animation-pop-up/upload-animation-pop-up.component';
import { LoyalticMissingTranslationHandler } from './core/handlers/LoyalticMissingTranslationHandler';
import { NotTranslatedService } from './core/helpers/not-translated-service.service';
import { HowToStepsComponent } from './modules/campaign/how-to-steps/how-to-steps.component';
import { CaptureAddressComponent } from './modules/shared/capture-address/capture-address.component';
import { CampaignEndedComponent } from './modules/campaign-ended/campaign-ended.component';
import { PointsSampleComponent } from './modules/campaign/points-sample/points-sample.component';
import { ProductsComponent } from './modules/campaign/products/products.component';
import { ScanParticipateComponent } from './modules/campaign/scan-participate/scan-participate.component';
import { PofLiveComponent } from './modules/campaign/scan-participate/pof-live/pof-live.component';
import { ScanComponent } from './modules/campaign/scan-participate/scan/scan.component';
import { SuccessComponent } from './modules/campaign/scan-participate/success/success.component';
import { ReportsComponent } from './modules/campaign/reports/reports.component';
import { ChartsModule } from 'ng2-charts';
import { StripePayComponent } from './modules/campaign/stripe-pay/stripe-pay.component';
import { StripeSuccessComponent } from './modules/campaign/stripe-success/stripe-success.component';
import { RewardsCarouselComponent } from './modules/campaign/rewards-carousel/rewards-carousel.component';
import { ReportsLoginComponent } from './modules/campaign/reports-login/reports-login.component';
import { ReceiptInsightsComponent } from './modules/campaign/receipt-insights/receipt-insights.component';
import { StripeCancelComponent } from './modules/campaign/stripe-cancel/stripe-cancel.component';
import { SwishPayComponent } from './modules/campaign/swish-pay/swish-pay.component';
import { SurveyScriptComponent } from './modules/campaign/survey-script/survey-script.component';




export class CustomLoader implements TranslateLoader {
  constructor(private http: HttpClient) { }
  getTranslation(lang: string): Observable<any> {
    return this.http.get(environment.baseUrl + Loyaltic.API.LocalizationByCulture + '?culture=' + lang).pipe(map(
      (res: any) => {
        const translation:any = {};
        res.forEach((element:any) => {
          translation[element.key] = element.text;
        });
        return translation;
      })
    );
  }
}

@NgModule({
  declarations: [
    ClickToPlayComponent,
    UploadReceiptComponent,
    LocalizationComponent,
    EmailReminderComponent,
    AppComponent,
    InfoComponent,
    LandingComponent,
    FeedbackComponent,
    FeedbackSuccessComponent,
    HeaderComponent,
    FooterComponent,
    SupportRulesComponent,
    SupportPolicyComponent,
    SupportProductsComponent,
    SupportFaqComponent,
    LayoutComponent,
    GenericPopUpComponent,
    ConfirmReceiptUploadComponent,
    DevNavigationComponent,
    CookieComponent,
    UploadAnimationPopUpComponent,
    RegisterComponent,
    RewardsListComponent,
    RewardsDeliverableComponent,
    RewardsDigitalComponent,
    CodeEntryComponent,
    ProfileComponent,
    MyProfileComponent,
    ProfileOrdersComponent,
    ProfileCodesComponent,
    UserPointsComponent,
    LoginComponent,
    ForgotPasswordComponent,
    CaptureAddressComponent,
    ResetPasswordComponent,
    HowToStepsComponent,
    CampaignEndedComponent,
    PointsSampleComponent,
    ProductsComponent,
    RewardsCarouselComponent,
    ScanParticipateComponent,
    PofLiveComponent,
    ScanComponent,
    SuccessComponent,
    ReportsComponent,
    StripePayComponent,
    StripeSuccessComponent,
    ReportsLoginComponent,
    StripeCancelComponent,
    SwishPayComponent,
    SurveyScriptComponent,
    ReceiptInsightsComponent
  ],
  imports: [
    CampaignModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    IconsModule,
    SharedModule,
    ToastrModule.forRoot({ preventDuplicates: true }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    ModalModule.forRoot(),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.doubleBounce,
      backdropBackgroundColour: "rgba(0, 0, 0, 0.52)",
      // backdropBorderRadius: '4px',
      primaryColour: "#fff",
      secondaryColour: "#fff",
      tertiaryColour: "#fff",
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomLoader,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: LoyalticMissingTranslationHandler,
        deps: [NotTranslatedService],
      },
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoyalticInterceptor, multi: true },
    { provide: "ImagePath", useValue: environment.ImagePath },
    BsModalRef,
    { provide: "googleTagManagerId", useValue: "G-NZXX77C8D1" },
    CookieService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
